import { render, staticRenderFns } from "./step_2.vue?vue&type=template&id=3ba30216&scoped=true&"
import script from "./step_2.vue?vue&type=script&lang=js&"
export * from "./step_2.vue?vue&type=script&lang=js&"
import style0 from "./step_2.vue?vue&type=style&index=0&id=3ba30216&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba30216",
  null
  
)

export default component.exports